/**
 * Previne a reimportação do módulo, permitindo que o mesmo somente seja importado no AppModule.
 */
export function throwIfAlreadyLoaded(parentModule: any, moduleName: string) {
  if (parentModule) {
    throw new Error(`${moduleName} já foi carregado. Você somente deve importar este módulo no AppModule.`);
  }
}
